/* 大额支付 */

<template>
  <div :class="[$style.wrap, fullScreen && $style.fullScreen]">
    <header>
      <span>支付</span>
      <img :src="`${$cdnLink}/wanXin/orangeTheme/fanhui.png`" :class="$style.fanhui" @click="back" />
    </header>
    <main>
      <div :class="$style.largeCharge">
        <div :class="$style.content">
          <RadioGroup :class="$style.payType" v-model="radio">
            <div
              v-for="(item, index) in largeChargeList"
              :key="index"
              :class="$style.listItem"
              @click="checked(item)"
            >
              <div>
                <img :src="payIcon(item.img_class_name)" alt />
                <span>{{ item.unite_name }}</span>
              </div>
              <Radio :name="item.pay_type" checked-color="#ff4f4b"></Radio>
            </div>
          </RadioGroup>
          <div :class="$style.price">
            <p>金额：</p>
            <input type="number" v-model.trim="money" />
          </div>
          <p :class="$style.hint">支付宝充值范围：10,000 - 1,000,000</p>
          <p :class="$style.hint">微信充值范围：10,000 - 500,000</p>
        </div>
        <Button @click="submit" :class="$style.toCharge">确认支付</Button>
      </div>
    </main>
  </div>
</template>  

<script>
import _ from 'lodash';
import { Button, RadioGroup, Radio } from 'vant';
import { mapState, mapActions, mapMutations } from 'vuex';
import isFullScreen from '@/libs/business/fullScreen';

export default {
  name: '',
  props: {
    isH5: {
      default: false
    }
  },
  data() {
    return {
      money: '',
      payType: {},
      radio: '',
      fullScreen: '',
    };
  },
  created() {
    this.fullScreen = isFullScreen();
  },
  mounted() {
    setTimeout(() => {
      if (this.largeChargeList.length) {
        this.radio = this.largeChargeList[0].pay_type;
        this.payType = this.largeChargeList[0]
      }
    }, 200);
  },
  components: {
    Button,
    RadioGroup,
    Radio
  },
  computed: {
    ...mapState({
      largeChargeList: (state) => state.pay.large_info
    })
  },
  methods: {
    ...mapMutations({
      changePayState: 'pay/CHANGE_STATE'
    }),
    ...mapActions({
      submitLargeCharge: 'pay/submitLargeCharge'
    }),
    payIcon(type) {
      if (type === 'alipay') return require('@/assets/images/pay/zfb.png');
      if (type === 'wechat') return require('@/assets/images/pay/wx.png');
      if (type === 'huabei') return require('@/assets/images/pay/huabei.svg');
      return require('@/assets/images/pay/visa.png');
    },
    checked(e) {
      this.radio = e.pay_type;
      this.payType = e;
    },
    async submit() {
      if (!this.money || Number(this.money) < 10000) {
        this.$toast('充值金额低于最低限制');
        return;
      }
      if (
        (this.payType.img_class_name == "alipay" &&
          Number(this.money) > 1000000) ||
        (this.payType.img_class_name == "wechat" && Number(this.money) > 500000)
      ) {
        this.$toast("充值金额超出上限");
        return;
      }
      await this.changePayState({
        pay_type: this.payType.pay_type,
        img_class_name: this.payType.img_class_name
      });
      this.submitLargeCharge(this.money)
    },
    back() {
      this.$emit('back');
    },
  }
};
</script>

<style lang="scss" module>
@import "../../assets/css/common.scss";
.wrap {
  @include common-window();
  z-index: 11;
  > header {
    position: relative;
    > span {
      font-weight: 600;
      font-style: italic;
    }
    .fanhui {
      position: absolute;
      top: .34rem;
      right: .34rem;
      width: .34rem;
      height: .24rem;
    }
  }
  > main {
    position: relative;
    .largeCharge {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      min-height: 100%;
      z-index: 10;
      text-align: center;
      font-size: .32rem;
      border-radius: .2rem;
      :global {
        .yw-guanbi {
          position: absolute;
          top: .15rem;
          right: .18rem;
          font-size: .5rem;
        }
        .yw-xiangzuo {
          position: absolute;
          top: .15rem;
          left: .18rem;
          font-size: .5rem;
        }
      }
      .title {
        text-align: center;
        line-height: .8rem;
        border-top-left-radius: .1rem;
        border-top-right-radius: .1rem;
        font-size: .36rem;
      }
      .content {
        padding: .15rem .4rem;
      }
      .payType {
        margin-top: .2rem;
        margin-bottom: .2rem;
        overflow: auto;
        .listItem {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-bottom: .1rem;
          border-bottom: 1px solid #ffffff;
          img {
            width: .36rem;
            height: .36rem;
            display: inline-block;
            margin-right: .2rem;
          }
          > div {
            display: flex;
            align-items: center;
          }
          .recommend {
            color: #ffffff;
            background: #ec911a;
            font-size: .2rem;
            padding: .08rem .18rem;
            border-radius: .4rem;
            margin-left: .1rem;
          }
          .recommendText {
            color: #ff452e;
            font-size: .18rem;
            margin-left: .05rem;
          }
        }
      }
      .price {
        font-size: .26rem;
        text-align: left;
        margin-bottom: .1rem;
        > input {
          width: 100%;
          border: none;
          margin-top: .05rem;
          font-size: .25rem;
          color: #000000;
          border-bottom: 1px solid #cccccc;
          padding: .03rem;
        }
      }
      .hint {
        text-align: left;
        color: #999999;
        line-height: .25rem;
        font-size: .2rem;
      }
      .toCharge {
        @include common-button();
        width: 4.8rem;
        height: .68rem;
        font-size: .24rem;
        border-radius: .84rem;
        display: block;
        margin: .1rem auto .2rem;
      }
    }
  }
  &.fullScreen {
    @include full-screen-window();
    z-index: 11;
    > header {
      position: relative;
      > span {
        font-weight: 600;
        font-style: italic;
      }
      .fanhui {
        position: absolute;
        top: 17px;
        right: 17px;
        width: 17px;
        height: 12px;
      }
    }
    > main {
      position: relative;
      .largeCharge {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        min-height: 100%;
        z-index: 10;
        text-align: center;
        font-size: 16px;
        border-radius: 10px;
        :global {
          .yw-guanbi {
            position: absolute;
            top: 7.5px;
            right: 9px;
            font-size: 25px;
          }
          .yw-xiangzuo {
            position: absolute;
            top: 7.5px;
            left: 9px;
            font-size: 25px;
          }
        }
        .title {
          text-align: center;
          line-height: 40px;
          border-top-left-radius: 5px;
          border-top-right-radius: 5px;
          font-size: 18px;
        }
        .content {
          padding: 7.5px 20px;
        }
        .payType {
          margin-top: 10px;
          margin-bottom: 10px;
          overflow: auto;
          .listItem {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 5px;
            border-bottom: 1px solid #ffffff;
            img {
              width: 18px;
              height: 18px;
              display: inline-block;
              margin-right: 10px;
            }
            > div {
              display: flex;
              align-items: center;
            }
            .recommend {
              color: #ffffff;
              background: #ec911a;
              font-size: 10px;
              padding: 4px 9px;
              border-radius: 20px;
              margin-left: 5px;
            }
            .recommendText {
              color: #ff452e;
              font-size: 9px;
              margin-left: 2.5px;
            }
          }
        }
        .price {
          font-size: 13px;
          text-align: left;
          margin-bottom: 15px;
          > input {
            width: 100%;
            border: none;
            margin-top: 2.5px;
            font-size: 25px;
            color: #000000;
            border-bottom: 1px solid #cccccc;
            padding: 1.5px;
          }
        }
        .hint {
          text-align: left;
          color: #999999;
          line-height: 12.5px;
          font-size: 10px;
        }
        .toCharge {
          @include full-screen-button();
          width: 240px;
          height: 34px;
          font-size: 12px;
          border-radius: 42px;
          display: block;
          margin: 10px auto 10px;
        }
      }
    }
  }
}
</style>